import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../../store';
import MyProfileView from './my-profile-view';

const MyProfileContainer = () => {
  const navigate = useNavigate();
  const { loggedInTraveler } = useAuthStore();

  const navigateToAccount = () => {
    navigate('/account');
  };

  return (
    <MyProfileView
      loggedInTravelerId={loggedInTraveler?.id}
      navigateToAccount={navigateToAccount}
    />
  );
};

export default MyProfileContainer;
